// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.respond-slider {
  width: 1100px;
  height: 100%;
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .respond-slider {
    width: 1200px;
  }
}
@media (max-width: 1400px) {
  .respond-slider {
    width: 70%;
  }
}
@media (max-width: 800px) {
  .respond-slider {
    width: 100%;
    gap: 24px;
  }
}
@media (max-width: 550px) {
  .respond-slider {
    height: unset;
    gap: 20px;
  }
}
.respond-slider .respond-slider-body {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.respond-slider .respond-slider-body .respond-item {
  width: 442px;
  height: 265px;
  padding: 48px;
  background-color: #FFFFFF;
  border-radius: 32px;
  border: 3px solid #EAEAEA;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.respond-slider .respond-slider-body .respond-item:nth-child(1) {
  transform: translateX(-0px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(2) {
  transform: translateX(-30px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(3) {
  transform: translateX(-60px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(4) {
  transform: translateX(-90px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(5) {
  transform: translateX(-120px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(6) {
  transform: translateX(-150px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(7) {
  transform: translateX(-180px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(8) {
  transform: translateX(-210px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(9) {
  transform: translateX(-240px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(10) {
  transform: translateX(-270px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(11) {
  transform: translateX(-300px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(12) {
  transform: translateX(-330px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(13) {
  transform: translateX(-360px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(14) {
  transform: translateX(-390px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(15) {
  transform: translateX(-420px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(16) {
  transform: translateX(-450px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(17) {
  transform: translateX(-480px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(18) {
  transform: translateX(-510px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(19) {
  transform: translateX(-540px);
}
.respond-slider .respond-slider-body .respond-item:nth-child(20) {
  transform: translateX(-570px);
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-body .respond-item {
    width: 592px;
    height: 314px;
    padding: 64px;
  }
}
@media (max-width: 1050px) {
  .respond-slider .respond-slider-body .respond-item {
    height: 313px;
  }
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-body .respond-item {
    height: 280px;
    width: 270px;
    padding: 24px;
    border-radius: 24px;
    border: 2px solid #EAEAEA;
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(1) {
    transform: translateX(-0px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(2) {
    transform: translateX(-12px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(3) {
    transform: translateX(-24px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(4) {
    transform: translateX(-36px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(5) {
    transform: translateX(-48px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(6) {
    transform: translateX(-60px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(7) {
    transform: translateX(-72px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(8) {
    transform: translateX(-84px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(9) {
    transform: translateX(-96px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(10) {
    transform: translateX(-108px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(11) {
    transform: translateX(-120px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(12) {
    transform: translateX(-132px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(13) {
    transform: translateX(-144px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(14) {
    transform: translateX(-156px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(15) {
    transform: translateX(-168px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(16) {
    transform: translateX(-180px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(17) {
    transform: translateX(-192px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(18) {
    transform: translateX(-204px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(19) {
    transform: translateX(-216px);
  }
  .respond-slider .respond-slider-body .respond-item:nth-child(20) {
    transform: translateX(-228px);
  }
}
.respond-slider .respond-slider-body .respond-item p {
  width: 100%;
  color: #313130;
  font-family: FixelText;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-body .respond-item p {
    font-family: FixelText;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-body .respond-item p {
    font-family: FixelText;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
}
.respond-slider .respond-slider-body .respond-item div {
  color: #575756;
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-body .respond-item div {
    gap: unset;
  }
}
.respond-slider .respond-slider-body .respond-item div .respond-item-position {
  letter-spacing: 0.14px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-body .respond-item div .respond-item-position {
    letter-spacing: 0.16px;
    font-family: FixelText;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-body .respond-item div .respond-item-position {
    letter-spacing: unset;
    font-family: FixelText;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.respond-slider .respond-slider-body .respond-item div .respond-item-name {
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-body .respond-item div .respond-item-name {
    font-family: FixelText;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-body .respond-item div .respond-item-name {
    font-family: FixelText;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  }
}
.respond-slider .respond-slider-controls {
  width: calc(100% - 80px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
@media (max-width: 1050px) {
  .respond-slider .respond-slider-controls {
    width: calc(100% - 40px);
  }
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-controls {
    width: 100%;
    gap: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.respond-slider .respond-slider-controls .respond-slider-dots {
  gap: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
@media (max-width: 550px) {
  .respond-slider .respond-slider-controls .respond-slider-dots {
    gap: 4px;
  }
}
.respond-slider .respond-slider-controls .respond-slider-dots .respond-dot {
  width: 12px;
  height: 12px;
  border-radius: 100px;
  background-color: #E0E0E0;
}
.respond-slider .respond-slider-controls .respond-slider-dots .respond-dot:first-child {
  width: 26px;
  background-color: #812456;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-controls .respond-slider-dots .respond-dot {
    width: 16px;
    height: 16px;
  }
  .respond-slider .respond-slider-controls .respond-slider-dots .respond-dot:first-child {
    width: 35px;
  }
}
.respond-slider .respond-slider-controls .respond-slider-buttons {
  gap: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev,
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  background-color: #EAEAEA;
  color: #812456;
  position: relative;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev,
  .respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next {
    width: 64px;
    height: 64px;
  }
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev svg,
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next svg {
  position: relative;
  z-index: 2;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev::before,
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next::before {
  content: "";
  width: 56px;
  height: 56px;
  border-radius: 100px;
  background-color: #812456;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
}
@media (min-width: 1620px) {
  .respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev::before,
  .respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next::before {
    width: 64px;
    height: 64px;
  }
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev:hover {
  color: #FFFFFF;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev svg {
  rotate: -90deg;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next:hover {
  color: #FFFFFF;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next svg {
  rotate: 90deg;
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-prev:hover::before {
  transform: translate(-50%, -50%) scale(1);
}
.respond-slider .respond-slider-controls .respond-slider-buttons .respond-slider-button-next:hover::before {
  transform: translate(-50%, -50%) scale(1);
}`, "",{"version":3,"sources":["webpack://./src/components/RespondSection/RespondSlider/RespondSlider.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ECNA,aAAA;EACA,sBDMqB;ECLrB,8BDK6B;ECJ7B,uBDI4C;AAChD;AACI;EAPJ;IAQQ,aAAA;EAEN;AACF;AAAI;EAXJ;IAYQ,UAAA;EAGN;AACF;AADI;EAfJ;IAgBQ,WAAA;IACA,SAAA;EAIN;AACF;AAFI;EApBJ;IAqBQ,aAAA;IACA,SAAA;EAKN;AACF;AAHI;EC3BA,aAAA;EACA,mBD2ByB;EC1BzB,2BD0B8B;ECzB9B,uBDyB0C;AAQ9C;AANQ;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBEhCJ;EFiCI,mBAAA;EACA,yBAAA;ECpCR,aAAA;EACA,sBDoC6B;ECnC7B,8BDmCqC;EClCrC,uBDkCoD;AAWxD;AATgB;EACI,2BAAA;AAWpB;AAZgB;EACI,4BAAA;AAcpB;AAfgB;EACI,4BAAA;AAiBpB;AAlBgB;EACI,4BAAA;AAoBpB;AArBgB;EACI,6BAAA;AAuBpB;AAxBgB;EACI,6BAAA;AA0BpB;AA3BgB;EACI,6BAAA;AA6BpB;AA9BgB;EACI,6BAAA;AAgCpB;AAjCgB;EACI,6BAAA;AAmCpB;AApCgB;EACI,6BAAA;AAsCpB;AAvCgB;EACI,6BAAA;AAyCpB;AA1CgB;EACI,6BAAA;AA4CpB;AA7CgB;EACI,6BAAA;AA+CpB;AAhDgB;EACI,6BAAA;AAkDpB;AAnDgB;EACI,6BAAA;AAqDpB;AAtDgB;EACI,6BAAA;AAwDpB;AAzDgB;EACI,6BAAA;AA2DpB;AA5DgB;EACI,6BAAA;AA8DpB;AA/DgB;EACI,6BAAA;AAiEpB;AAlEgB;EACI,6BAAA;AAoEpB;AAhEY;EAdJ;IAeQ,YAAA;IACA,aAAA;IACA,aAAA;EAmEd;AACF;AAjEY;EApBJ;IAqBQ,aAAA;EAoEd;AACF;AAlEY;EAxBJ;IAyBQ,aAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;EAqEd;EAnEkB;IACI,2BAAA;EAqEtB;EAtEkB;IACI,4BAAA;EAwEtB;EAzEkB;IACI,4BAAA;EA2EtB;EA5EkB;IACI,4BAAA;EA8EtB;EA/EkB;IACI,4BAAA;EAiFtB;EAlFkB;IACI,4BAAA;EAoFtB;EArFkB;IACI,4BAAA;EAuFtB;EAxFkB;IACI,4BAAA;EA0FtB;EA3FkB;IACI,4BAAA;EA6FtB;EA9FkB;IACI,6BAAA;EAgGtB;EAjGkB;IACI,6BAAA;EAmGtB;EApGkB;IACI,6BAAA;EAsGtB;EAvGkB;IACI,6BAAA;EAyGtB;EA1GkB;IACI,6BAAA;EA4GtB;EA7GkB;IACI,6BAAA;EA+GtB;EAhHkB;IACI,6BAAA;EAkHtB;EAnHkB;IACI,6BAAA;EAqHtB;EAtHkB;IACI,6BAAA;EAwHtB;EAzHkB;IACI,6BAAA;EA2HtB;EA5HkB;IACI,6BAAA;EA8HtB;AACF;AA1HY;EACI,WAAA;EACA,cE5DT;EDFH,sBD+DiC;EC9DjC,eD8D4C;EC7D5C,kBD6DkD;EC5DlD,gBD4D0D;EC3D1D,iBD2D+D;AAgInE;AA9HgB;EALJ;IC5DR,sBDkEqC;ICjErC,eDiEgD;IChEhD,kBDgEsD;IC/DtD,gBD+D8D;IC9D9D,iBD8DmE;EAqIrE;AACF;AAnIgB;EATJ;IC5DR,sBDsEqC;ICrErC,eDqEgD;ICpEhD,kBDoEsD;ICnEtD,gBDmE8D;IClE9D,iBDkEmE;EA0IrE;AACF;AAvIY;EACI,cE3EJ;EF4EI,QAAA;ECnFZ,aAAA;EACA,sBDmFiC;EClFjC,8BDkFyC;ECjFzC,uBDiFwD;AA4I5D;AA1IgB;EALJ;IAMQ,UAAA;EA6IlB;AACF;AA3IgB;EACI,sBAAA;EACA,yBAAA;ECrFhB,yBDsFqC;ECrFrC,eDqFmD;ECpFnD,kBDoFyD;ECnFzD,gBDmFiE;EClFjE,iBDkFsE;AAiJ1E;AA/IoB;EALJ;IAMQ,sBAAA;ICzFpB,sBD0FyC;ICzFzC,eDyFoD;ICxFpD,kBDwF0D;ICvF1D,gBDuFkE;ICtFlE,iBDsFuE;EAsJzE;AACF;AApJoB;EAVJ;IAWQ,qBAAA;IC9FpB,sBD+FyC;IC9FzC,eD8FoD;IC7FpD,kBD6F0D;IC5F1D,gBD4FkE;IC3FlE,iBD2FuE;EA2JzE;AACF;AAxJgB;EACI,yBAAA;ECpGhB,yBDqGqC;ECpGrC,eDoGmD;ECnGnD,kBDmGyD;EClGzD,gBDkGiE;ECjGjE,iBDiGsE;AA8J1E;AA5JoB;EAJJ;ICnGZ,sBDwGyC;ICvGzC,eDuGoD;ICtGpD,kBDsG0D;ICrG1D,gBDqGkE;ICpGlE,iBDoGuE;EAmKzE;AACF;AAjKoB;EARJ;ICnGZ,sBD4GyC;IC3GzC,eD2GoD;IC1GpD,kBD0G0D;ICzG1D,gBDyGkE;ICxGlE,iBDwGuE;EAwKzE;AACF;AAjKI;EACI,wBAAA;EC5HJ,aAAA;EACA,mBD4HyB;EC3HzB,8BD2H8B;EC1H9B,qBD0H6C;AAsKjD;AApKQ;EAJJ;IAKQ,wBAAA;EAuKV;AACF;AArKQ;EARJ;IASQ,WAAA;IACA,SAAA;ICrIR,aAAA;IACA,sBDqI6B;ICpI7B,uBDoIqC;ICnIrC,mBDmI6C;EA2K/C;AACF;AAzKQ;EACI,QAAA;EC1IR,aAAA;EACA,mBD0I6B;ECzI7B,8BDyIkC;ECxIlC,qBDwIiD;AA8KrD;AA5KY;EAJJ;IAKQ,QAAA;EA+Kd;AACF;AA7KY;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBE/IF;AF8Td;AA7KgB;EACI,WAAA;EACA,yBErJX;AFoUT;AA5KgB;EAXJ;IAYQ,WAAA;IACA,YAAA;EA+KlB;EA7KkB;IACI,WAAA;EA+KtB;AACF;AA1KQ;EACI,SAAA;ECxKR,aAAA;EACA,mBDwK6B;ECvK7B,8BDuKkC;ECtKlC,qBDsKiD;AA+KrD;AA7KY;;EAEI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBE3KT;EF4KS,cE7KP;EF8KO,kBAAA;EACA,kCAAA;EACA,eAAA;ECpLZ,aAAA;EACA,mBDoLiC;ECnLjC,uBDmLsC;EClLtC,mBDkL8C;AAkLlD;AAhLgB;EAZJ;;IAaQ,WAAA;IACA,YAAA;EAoLlB;AACF;AAlLgB;;EACI,kBAAA;EACA,UAAA;AAqLpB;AAlLgB;;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBElMX;EFmMW,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,sCAAA;EACA,wBAAA;AAqLpB;AAnLoB;EAbJ;;IAcQ,WAAA;IACA,YAAA;EAuLtB;AACF;AAjLgB;EACI,cEtNZ;AFyYR;AAhLgB;EACI,cAAA;AAkLpB;AA5KgB;EACI,cEjOZ;AF+YR;AA3KgB;EACI,aAAA;AA6KpB;AAzKY;EACI,yCAAA;AA2KhB;AAxKY;EACI,yCAAA;AA0KhB","sourcesContent":["@use '../../../styles/mixins.scss';\n@import '../../../styles/variables.scss';\n\n.respond-slider {\n    width: 1100px;\n    height: 100%;\n    position: relative;\n    z-index: 3;\n    @include mixins.flex(column, space-between, flex-start);\n\n    @media (min-width: 1620px) {\n        width: 1200px;\n    }\n\n    @media (max-width: 1400px) {\n        width: 70%;\n    }\n\n    @media (max-width: 800px) {\n        width: 100%;\n        gap: 24px;\n    }\n\n    @media (max-width: 550px) {\n        height: unset;\n        gap: 20px;\n    }\n\n    .respond-slider-body {\n        @include mixins.flex(row, flex-start, flex-start);\n\n        .respond-item {\n            width: 442px;\n            height: 265px;\n            padding: 48px;\n            background-color: $white;\n            border-radius: 32px;\n            border: 3px solid $grey;\n            @include mixins.flex(column, space-between, flex-start);\n            @for $i from 1 through 20 {\n                &:nth-child(#{$i}) {\n                    transform: translateX(-#{($i - 1) * 30}px);\n                }\n            }\n\n            @media (min-width: 1620px) {\n                width: 592px;\n                height: 314px;\n                padding: 64px;\n            }\n\n            @media (max-width: 1050px) {\n                height: 313px;\n            }\n            \n            @media (max-width: 550px) {\n                height: 280px;\n                width: 270px;\n                padding: 24px;\n                border-radius: 24px;\n                border: 2px solid $grey;\n                @for $i from 1 through 20 {\n                    &:nth-child(#{$i}) {\n                        transform: translateX(-#{($i - 1) * 12}px);\n                    }\n                }\n            }\n\n            p {\n                width: 100%;\n                color: $dark;\n                @include mixins.font(FixelText, 16px, normal, 400, 140%);\n\n                @media (min-width: 1620px) {\n                    @include mixins.font(FixelText, 20px, normal, 400, 140%);\n                }\n\n                @media (max-width: 550px) {\n                    @include mixins.font(FixelText, 14px, normal, 400, 140%);\n                }\n            }\n\n            div {\n                color: $grey-dark;\n                gap: 8px;\n                @include mixins.flex(column, space-between, flex-start);\n\n                @media (max-width: 550px) {\n                    gap: unset;\n                }\n\n                .respond-item-position {\n                    letter-spacing: 0.14px;\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                    @media (min-width: 1620px) {\n                        letter-spacing: 0.16px;\n                        @include mixins.font(FixelText, 16px, normal, 500, 110%);\n                    }\n\n                    @media (max-width: 550px) {\n                        letter-spacing: unset;\n                        @include mixins.font(FixelText, 14px, normal, 500, 130%);\n                    }\n                }\n\n                .respond-item-name {\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 24px, normal, 600, 100%);\n\n                    @media (min-width: 1620px) {\n                        @include mixins.font(FixelText, 32px, normal, 600, 100%);\n                    }\n\n                    @media (max-width: 550px) {\n                        @include mixins.font(FixelText, 20px, normal, 600, 120%);\n                    }\n                }\n            }\n        }\n    }\n\n\n    .respond-slider-controls {\n        width: calc(100% - 80px);\n        @include mixins.flex(row, space-between, flex-end);\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 40px);\n        }\n\n        @media (max-width: 550px) {\n            width: 100%;\n            gap: 24px;\n            @include mixins.flex(column, center, center);\n        }\n\n        .respond-slider-dots {\n            gap: 8px;\n            @include mixins.flex(row, space-between, flex-end);\n\n            @media (max-width: 550px) {\n                gap: 4px;  \n            }\n\n            .respond-dot {\n                width: 12px;\n                height: 12px;\n                border-radius: 100px;\n                background-color: $grey-opacity;\n\n                &:first-child {\n                    width: 26px;\n                    background-color: $purple;\n                }\n\n                @media (min-width: 1620px) {\n                    width: 16px;\n                    height: 16px;\n\n                    &:first-child {\n                        width: 35px;\n                    }\n                }\n            }\n        }\n\n        .respond-slider-buttons {\n            gap: 12px;\n            @include mixins.flex(row, space-between, flex-end);\n\n            .respond-slider-button-prev,\n            .respond-slider-button-next {\n                width: 56px;\n                height: 56px;\n                border-radius: 100px;\n                background-color: $grey;\n                color: $purple;\n                position: relative;\n                transition: color 0.3s ease-in-out;\n                cursor: pointer;\n                @include mixins.flex(row, center, center);\n\n                @media (min-width: 1620px) {\n                    width: 64px;\n                    height: 64px;\n                }\n\n                svg {\n                    position: relative;\n                    z-index: 2;\n                }\n\n                &::before {\n                    content: '';\n                    width: 56px;\n                    height: 56px;\n                    border-radius: 100px;\n                    background-color: $purple;\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%) scale(0);\n                    transition: transform 0.3s ease-in-out;\n                    transform-origin: center;\n\n                    @media (min-width: 1620px) {\n                        width: 64px;\n                        height: 64px;\n                    }\n                }\n            }\n\n            .respond-slider-button-prev {\n\n                &:hover {\n                    color: $white;\n                }\n\n                svg {\n                    rotate: -90deg;\n                }\n            }\n\n            .respond-slider-button-next {\n\n                &:hover {\n                    color: $white;\n                }\n\n                svg {\n                    rotate: 90deg;\n                }\n            }\n\n            .respond-slider-button-prev:hover::before {\n                transform: translate(-50%, -50%) scale(1);\n            }\n\n            .respond-slider-button-next:hover::before {\n                transform: translate(-50%, -50%) scale(1);\n            }\n        }\n    }\n}","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
